<template>
    <GameLoading v-if="!error" label="正在登录游戏" />
    <main v-else class="sso-container" aria-live="polite">
        <h1>游戏登录未完成</h1>
        <p>{{ error }}</p>
        <a href="/workspace">返回登录页面</a>
    </main>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { setLocale } from '../i18n';
import { loginSignedSSO } from '../workspace/api.mjs';
import GameLoading from '../workspace/components/GameLoading.vue';
import {clearEntryTimeline} from '../workspace/entryTimeline.mjs';
const error = ref('');
// Keep signed credentials in memory only and remove them before any redirect.
const query = window.location.search;
window.history.replaceState(null, '', window.location.pathname);
// Clear legacy versions that persisted the entire signed query.
try { localStorage.removeItem('sso_params'); } catch { /* storage can be unavailable */ }
const lang = new URLSearchParams(query).get('lang');
if (lang) setLocale(lang);
onMounted(async () => {
    try {
        const entry = await loginSignedSSO(query);
        try { localStorage.setItem('sso_params', JSON.stringify(entry.context)); }
        catch { /* authentication uses cookies; optional coach context may be unavailable */ }
        window.location.replace(entry.destination);
    } catch (e) {
        clearEntryTimeline();
        error.value = e.name === 'TimeoutError' || e.name === 'AbortError'
            ? '登录服务响应超时，请检查 13003 工作区服务后重新打开登录链接。'
            : e instanceof TypeError ? '无法连接游戏登录服务，请检查服务和代理配置。' : e.message;
    }
});
</script>

<style scoped>
.sso-container { display:flex; flex-direction:column; align-items:center; justify-content:center; gap:16px; min-height:100vh; padding:24px; box-sizing:border-box; text-align:center; color:#273449; background:#f5f7fb; }
h1 { font-size:22px; margin:0; }
p { max-width:520px; margin:0; line-height:1.7; }
a { color:#2563eb; }
</style>
